// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3R0-F","content":"RecentSearches_content__3cBJI"};